import { CrudHttpRepository, HttpMethod } from "../../core/repository/http_repository";
import { TaskValidationModel } from "./task_model";

export class TaskHttpRepository extends CrudHttpRepository<TaskValidationModel> {
    featurePath: string = '/tasks'
    getPage = (page = 0, filters: Record<string, string> = {}) => {
        const query = new URLSearchParams({ page: String(page), ...filters });
        return this._jsonRequest<TaskValidationModel[]>(HttpMethod.GET, `${this.featurePath}?${query}`);
    };
    getOne = (id: string) => this._jsonRequest<TaskValidationModel>(HttpMethod.GET, `${this.featurePath}?id=${encodeURIComponent(id)}`);
    save = (model: TaskValidationModel) => this._jsonRequest<{ id?: string; _id?: string }>(model._id ? HttpMethod.PUT : HttpMethod.POST, this.featurePath, model);
    uploadImage = (file: File) => this._formDataRequest<{ url: string }>(HttpMethod.POST, `${this.featurePath}/images`, file);
}
